// extracted by mini-css-extract-plugin
export default {"containerSelect":"DialogTestPoll_containerSelect__pK5He"};